document.addEventListener("DOMContentLoaded", function () {
  const listContainer = document.querySelector('.js-list');
  const items = listContainer.querySelectorAll('.o-grid');
  const loadMoreBtn = listContainer.querySelector('.js-load-more');
  const hideCount = parseInt(listContainer.dataset.hide, 10) || 0;

  let visibleCount = items.length - hideCount;

  // Dodaj klasę ukrywającą z animacją
  items.forEach((item, index) => {
    if (index >= visibleCount) {
      item.classList.add('is-hidden');
    }
  });

  loadMoreBtn.addEventListener('click', function () {
    const hiddenItems = listContainer.querySelectorAll('.o-grid.is-hidden');
    let count = 0;

    hiddenItems.forEach(item => {
      if (count < hideCount) {
        item.classList.remove('is-hidden');
        item.classList.add('fade-in');

        // Usunięcie klasy po zakończeniu animacji (dla czystości)
        item.addEventListener('transitionend', function cleanup() {
          item.classList.remove('fade-in');
          item.removeEventListener('transitionend', cleanup);
        });

        count++;
      }
    });

    if (hiddenItems.length <= hideCount) {
      loadMoreBtn.style.display = 'none';
    }
  });
});
